import { render } from "./HomeTimeBasedGanttChart.vue?vue&type=template&id=6536046c&scoped=true"
import script from "./HomeTimeBasedGanttChart.vue?vue&type=script&lang=js"
export * from "./HomeTimeBasedGanttChart.vue?vue&type=script&lang=js"

import "./HomeTimeBasedGanttChart.vue?vue&type=style&index=0&id=6536046c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6536046c"]])

export default __exports__